/* eslint-disable */
// prettier-ignore-start
import { Container, Row, Col } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

const Welcome = () => {

  const history = useHistory();
  return (
      <Container className="subscriber-container">
        <Row className="justify-content-center">
        <Col md={11}>
          <h3 data-testid="welcome">
          Welcome to the National Traffic Information Service (NTIS) Data
          Subscription Portal.
          </h3>
          <div className="subscriber-content">
          <h5>
            Thank you for considering becoming a subscriber to our free
            real-time data and information service.
          </h5>
          <br />
          <h6>
            Utilising DATEX II feeds, you will be able to obtain data and
            information which is collected every minute of every day, from
            Motorways and major A roads.
          </h6>
          <h6>
            The available feeds include the following, please see the ‘Available feeds’ section for a full list.
          </h6>
          <ul>
            <li>
            Raw Traffic Data - Unprocessed Traffic data collected from on
            road equipment - Motorway Incident Detection and Automatic
            Signalling (MIDAS) system and Traffic Monitoring Units (TMU).
            </li>
            <li>
            Fused Traffic Data – Processed data consisting of Raw Traffic
            data and in-vehicle traffic data.
            </li>
            <li>
            Event data – information from the NTIS system on what incidents,
            including road works, are happening on the network
            </li>
            <li>
            Location reference data which allows you to align the data to
            your network model
            </li>
          </ul>
          <p>
            This data can then be used by you to populate your own traffic
            information website, Smartphone application or similar.
          </p>
          <h6>It is free to register and receive the data.</h6>
          <p>
            Registering to become a subscriber is easy – just agree to our
            acceptable use and operational policy and complete the
            registration form which is accessed from the link at the top of
            this page.
          </p>
          {/* <p>
            For the technical aspects of the service please refer to the
            following pages.
          </p> */}
          <p>
            If you have any questions please see our 
            <button
                      className="click-here"
                      onClick={() => history.push('/subscriberportal/contactus')}
                      tabIndex={0}
                      data-testid="click-here"
                      role="button"
                    >
                       contact
                    </button> page.
          </p>
          </div>
        </Col>
        </Row>
      </Container>
  );
};
export default Welcome;
